import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {CoreService} from '../../helper/core/core.service';
import {ActivatedRoute, Router, ParamMap} from '@angular/router';
import {NgModel, FormGroup, FormBuilder} from '@angular/forms';
import {registerLocaleData, Location} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import {BuNameService} from '../../helper/core/bu-name.service';
import {UtilsService} from '../../helper/utils/utils.service';
import {NgSelectComponent} from '@ng-select/ng-select';


@Component({
  selector: 'app-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss']
})
export class DateComponent implements OnInit {


  @ViewChild('regionComp') regionComp: NgSelectComponent;
  @ViewChild('villeComp') villeComp: NgSelectComponent;
  @ViewChild('lieuComp') lieuComp: NgSelectComponent;
  
  public buSlug: string = "";
  public eventSlug: string = "";
  public event: any = false;
  public errorMsg: string = "";
  public errorApi: boolean = false;
  public today: Date = new Date();

  public formPlaces: FormGroup;
  public objectKeys = Object.keys
  public filtres: any;
  public dataBoutiques: any = false;

  public dataBoutiquesOther: any = false;
  
  @Input() data;
  @Output() dataChange = new EventEmitter();

  constructor(private route: ActivatedRoute,
              private coreService: CoreService,
              private buNameService: BuNameService,
              private fb: FormBuilder,
              private router: Router,
              private utils: UtilsService,
              private location: Location) {
  }

  ngOnInit() {
    $(document).ready(function () {
      $(document).foundation();
    });

    this.initSliderSlots()
    
    registerLocaleData(localeFr, 'fr');
  }

  private initSliderSlots(): void {
    $('.event__slider-slots').each((index, element) => {

      $(element).addClass('swiper-' + index);
      $(element).find(".swiper-button-prev").addClass("btn-prev-" + index);
      $(element).find(".swiper-button-next").addClass("btn-next-" + index);

      new Swiper('.swiper-' + index, {
        loop: false,
        slidesPerView: 3,
        spaceBetween: 0,
        slideClass: 'swiper-slide',
        autoplay: false,
        navigation: {
          nextEl: ".btn-next-" + index,
          prevEl: ".btn-prev-" + index
        },
        breakpoints: {
          1280: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 2
          }
        }
      })

    });
  }


  /**
   * Lien d'enregistrement à l'évènement
   * @param idSlot id du slot
   * @param nbPlaces nombre de places restantes
   * @param start_time timestamp de début de session
   * @param end_time timestamp de fin de session
   */
  private linkToregister(idSlot, nbPlaces, start_time, end_time): void {
    const start_date = new Date(start_time);
    const end_date = new Date(end_time);
    utag.link({
      'track_zone' : this.event.buSlug + '_' + this.event.slug + '_creneau',
      'track_nom' : start_date.toLocaleDateString() + '_' + (start_date.getHours() + 1) + 'h' + (start_date.getMinutes() ? start_date.getMinutes() : '') + '/' + (end_date.getHours() + 1) + 'h' + (end_date.getMinutes() ? end_date.getMinutes() : ''),
      'track_cible' :  window.location.origin + '/' + this.buSlug + '/' + this.eventSlug + '/' + 'register' + '?id=' + idSlot
    });

    if (nbPlaces && start_time > this.today.getTime()) {
      this.router.navigate(
        ['/' + this.buSlug, this.eventSlug, 'register'],
        {queryParams: {'id': idSlot} });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/todo_remove/date/date.component.ts